"use strict";
module.exports = {
    entityModel: 'organization',
    events: {
        ORGANIZATION_UPDATED: 'ORGANIZATION_UPDATED',
        ORGANIZATION_CREATED: 'ORGANIZATION_CREATED',
        ORGANIZATION_PUBLISHED_ON_QVANTI: 'ORGANIZATION_PUBLISHED_ON_QVANTI',
        ORGANIZATION_UNPUBLISHED_ON_QVANTI: 'ORGANIZATION_UNPUBLISHED_ON_QVANTI',
    },
    actions: {
        get: 'v1.organization.get',
        list: 'v1.organization.list',
        createSupplierAndOrganisation: 'v1.organization.createSupplierAndOrganisation',
        publishOnQvanti: 'v1.organization.publishOnQvanti',
        unpublishOnQvanti: 'v1.organization.unpublishOnQvanti',
        upsert: 'v1.organization.upsert',
        upsertWhenEmpty: 'v1.organization.upsertWhenEmpty',
        updateWhenEmpty: 'v1.organization.updateWhenEmpty',
        update: 'v1.organization.update',
    },
    subscriptionLevels: {
        basic: 'basic',
        flaivy: 'flaivy',
        flaivyplus: 'flaivyplus',
        enterprise: 'enterprise',
    },
    zipCodeToOfcMaps: {},
    organizationCustomFields: {
        entityTypes: {
            article: 'article',
            order: 'order',
            supplier: 'supplier',
            supplierCustomer: 'supplierCustomer',
            purchaseOrder: 'purchaseOrder',
            invoice: 'invoice',
            priceList: 'priceList',
            settlement: 'settlement',
        },
        fieldTypes: {
            string: 'string',
            select: 'select',
            number: 'number',
            boolean: 'boolean',
            date: 'date',
        },
    },
};
